export class ReportPagination {
    offset: number;
    rowCount: number;
}
